import styled from 'styled-components';

export const UiOrganization = styled.div`
	display: block;
`;
